import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteSpotlight = {
  name: "deleteSpotlight" as const,
  input: z.object({ spotlightId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
